import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { howitworks } from './howitwork';


function HowitWorks() {
    const navigate = useNavigate();
    return (
        <>
            <div className='bg-back py-5'>
                <h2 className='text-center text-white '>How MDBOT Works</h2>
                <hr />
                <div className="row justify-content-center align-items-center">
                    {Array.isArray(howitworks) && howitworks.map((item, index) => {
                        return <>
                            <div key={index + item} className='row mb-3 col-lg-4 p-5  justify-content-center align-items-center'>
                                <div style={{ height: '100%' }} className='bg-white  rounded rounded-4 shadow'>
                                    <div className="p-5 text-center ">
                                        <img height={150} width={150} className='img-fluid' src={item.image} alt={item.title} />
                                    </div>
                                    <div style={{ fontSize: '1rem' }} className='p-2' >
                                        <h3 className='text-center robotText'>{item.title}</h3>
                                        <p>{item.details}</p>
                                    </div>
                                </div>
                            </div>
                        </>
                    })}
                </div>
            </div>
        </>
    )
}
export default HowitWorks
